import { render, staticRenderFns } from "./planningadmin.vue?vue&type=template&id=f067342e&scoped=true&"
import script from "./planningadmin.vue?vue&type=script&lang=js&"
export * from "./planningadmin.vue?vue&type=script&lang=js&"
import style0 from "./planningadmin.vue?vue&type=style&index=0&id=f067342e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f067342e",
  null
  
)

export default component.exports